import { forwardRef } from 'react';

import Button from 'atoms/button';
import useWindowDimensions from 'hooks/useWindowDimensions';
import CalendarViewFilter from 'organisms/CalendarViewFilter';
import GroomersDropdown from 'organisms/GroomersDropdown';
import NewAppointmentButton from 'organisms/NewAppointmentButton';

import DatePicker from './DatePicker';

const Header = forwardRef(({ dateStart, openRecurringDrawer }, ref) => {
  const { width } = useWindowDimensions();
  const isMobile = width <= 600;
  return (
    <div className="appointments-page-header pos-absolute flex-row">
      <DatePicker ref={ref} date={dateStart} />
      <CalendarViewFilter />
      <NewAppointmentButton />
      <Button
        text="Edit availability"
        className="fw-400"
        shape="round"
        size="small"
        variant="white-outlined"
        onClick={openRecurringDrawer}
      />
      <GroomersDropdown />
    </div>
  );
});

export default Header;
